<template>
  <v-dialog v-model="consolidar" fullscreen hide-overlay lazy transition="dialog-bottom-transition">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="!fechado"
        color="red lighten-2"
        dark
        small
        v-on="on"
      >
        CONSOLIDAR
      </v-btn>
      <v-btn
        v-else
        color="success"
        dark
        small
        v-on="on"
      >
        FECHADO
      </v-btn>
    </template>
    <consolidar v-if="consolidacao" @fechar="consolidar = false" :fechado="fechado" :consolidacao="consolidacao" @fecharConsolidacao="fecharConsolidacao"></consolidar>
  </v-dialog>
</template>

<script>
import Consolidar from '@/components/dialogs/Consolidar'

export default {
  components: { Consolidar },
  props: ['dia', 'fechado'],
  data () {
    return {
      consolidar: false,
      consolidacao: null
    }
  },
  watch: {
    consolidar (val) {
      if (val !== null && val !== undefined & val === true) {
        this.carregarRelatorio()
      }
    }
  },
  computed: {
    consolidado () {
      return false
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    fecharConsolidacao () {
      this.$store.dispatch('fecharConsolidacaoPagamento', this.dia).then(() => {
        this.$emit('consolidarPagamento', this.dia)
        this.consolidar = false
      })
    },
    carregarRelatorio () {
      this.$store.dispatch('relatorioComprasCallback', {
        confirmado: true,
        recompra: false,
        data_compra: this.dia,
        em_especie: false
      }).then(compras => {
        this.consolidacao = {
          competencia: this.dia,
          files: [],
          compras: compras.map((data) => {
            return {
              apetrus: true,
              pendente: false,
              consolidada: data.consolidada,
              num_cartao: data.num_cartao,
              combustivel: data.combustivel,
              tid: data.token,
              nsu: data.nsu,
              reference: data.id_compra,
              valor: data.valor,
              data_compra: data.data_compra.split('-').reverse().join('/'),
              cliente: {
                nome: data.cliente.pessoa.nome,
                sobrenome: data.cliente.pessoa.sobrenome,
                email: data.cliente.pessoa.email,
                telefone: data.cliente.pessoa.telefone
              }
            }
          })
        }
      })
    }
  }
}
</script>
